import { AppBar, Toolbar, Container, Box } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { Navigation } from './Navigation'
import { MobileNav } from './MobileNav'
import { Button } from '@/components/common'
import { primaryCTA } from '@/data/navigation'
import { HEADER_HEIGHT } from '@/utils/constants'

/**
 * Site Header Component
 * Fixed header with logo, navigation, and CTA
 */
export const Header = () => {
  const navigate = useNavigate()

  const handleCTAClick = () => {
    navigate(primaryCTA.href)
  }

  const handleLogoClick = () => {
    navigate('/')
  }

  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        backgroundColor: '#0f1b2e',
        color: '#ffffff',
        height: HEADER_HEIGHT,
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
      }}
    >
      <Toolbar
        sx={{
          height: '100%',
          minHeight: HEADER_HEIGHT,
          px: { xs: 2, sm: 3 },
        }}
      >
        <Container
          maxWidth="xl"
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            height: '100%',
            px: { xs: 0, sm: 2 },
          }}
        >
          {/* Logo */}
          <Box
            component="img"
            src="/assets/images/leru-logo.png"
            alt="Leru Systems"
            onClick={handleLogoClick}
            sx={{
              height: { xs: '60px', sm: '70px' },
              width: 'auto',
              cursor: 'pointer',
              transition: 'opacity 0.2s ease',
              '&:hover': {
                opacity: 0.8,
              },
            }}
          />

          {/* Desktop Navigation */}
          <Navigation />

          {/* CTA Button */}
          <Box sx={{ display: { xs: 'none', md: 'block' } }}>
            <Button variant="primary" onClick={handleCTAClick}>
              {primaryCTA.label}
            </Button>
          </Box>

          {/* Mobile Navigation */}
          <MobileNav />
        </Container>
      </Toolbar>
    </AppBar>
  )
}
